import { render, staticRenderFns } from "./FDHome.vue?vue&type=template&id=2a10a4b6&"
import script from "./FDHome.vue?vue&type=script&lang=js&"
export * from "./FDHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports